import { Col, Input, Modal, Row, Space, Table, Typography } from 'antd';
import { LinkButton } from 'components';
import React, { useEffect, useState } from 'react';
import { getUser } from 'services/users';

/**
 * 인사정보(Human Resource)를 조회하고 선택하는 컴포넌트
 * @param {string} title 모달 제목
 * @param {boolean} visible 모달 visible
 * @param {function} onCancel 모달 cancel 로직
 * @param {function} onOk 모달 ok 로직
 * @returns ReactNode
 */
function SelectHR({ title, visible, onCancel, onOk, searchValue }) {
  const [search, setSearch] = useState('');
  const [dataSource, setDataSource] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const [searchData, setSearchData] = React.useState(searchValue);

  useEffect(() => {
    if (!searchValue?.value) {
      return;
    }

    setSearchData(searchValue);
    setSearch(searchValue);
    getUser(searchValue).then((data) => setDataSource(data));
  }, [searchValue]);

  useEffect(() => {
    if (!search?.value) {
      return;
    }
    getUser(search).then((data) => setDataSource(data));
  }, [search]);
  return (
    <Modal
      title={title}
      visible={visible}
      closable
      width={740}
      cancelText="취소"
      okText="선택"
      onCancel={() => {
        onCancel();
        setSelectedUser(undefined);
        setDataSource([]);
        setSearch({});
        setSearchData({});
      }}
      onOk={() => {
        onOk(selectedUser);
        // setSelectedUser(undefined);
        setDataSource([]);
        setSearch({});
        setSearchData({});
      }}
      centered
    >
      <Row>
        <Col>
          <Input.Search
            size="small"
            placeholder="사용자 ID 검색"
            style={{ width: 240 }}
            value={searchData?.value}
            onSearch={() => setSearch(searchData)}
            onChange={(e) =>
              setSearchData((prev) => ({
                ...prev,
                type: 'sAMAccountName',
                value: e.target.value,
              }))
            }
          />
        </Col>
      </Row>
      {search ? (
        <Table
          size="small"
          rowKey="dn"
          dataSource={dataSource}
          columns={[
            {
              title: '이름',
              dataIndex: 'userName',
              render: (text) => <LinkButton>{text}</LinkButton>,
            },
            { title: '사용자 ID', dataIndex: 'sAMAccountName' },
            // { title: '직급', dataIndex: 'position' },
            { title: '부서', dataIndex: 'organization' },
            // { title: '재직 여부', dataIndex: 'work', width: 90 },
          ]}
          rowSelection={{
            type: 'radio',
            onSelect: (record) => {
              setSelectedUser(record);
            },
          }}
        />
      ) : (
        <div style={{ display: 'flex', marginTop: 20, justifyContent: 'center' }}>
          사용자를 검색하세요
        </div>
      )}
    </Modal>
  );
}

export function UserSearchInput({ readOnly1, value, onChange, onSuccess, userName }) {
  const [text, setText] = React.useState('');
  const [selectUserModal, setSelectUserModal] = React.useState({});
  // const [searchType, setSearchType] = React.useState('name');
  const [userNm, setUserNm] = React.useState('');

  useEffect(() => {
    setText(value);
  }, [value]);

  return readOnly1 ? (
    <Typography.Text>
      {userName}({text})
    </Typography.Text>
  ) : (
    <>
      <Space>
        <Input.Search
          size="small"
          value={text}
          style={{ marginBottom: 8 }}
          placeholder="사용자 ID 검색"
          onChange={(e) => {
            setText(e.target.value);
            setUserNm('');
          }}
          onSearch={() => {
            setSelectUserModal({
              title: '사용자 선택',
              visible: true,
              value: { type: 'sAMAccountName', value: text },
            });
          }}
        />
        {userNm && (
          <Typography.Text>
            사용자 : {userNm}({text})
          </Typography.Text>
        )}
      </Space>
      <SelectHR
        title={selectUserModal?.title}
        visible={selectUserModal?.visible}
        searchValue={selectUserModal?.value}
        onCancel={() => setSelectUserModal(undefined)}
        onOk={(selectedUser) => {
          // 여기서 onchange
          setText(selectedUser?.sAMAccountName || '');
          setUserNm(selectedUser?.userName);
          onChange(selectedUser?.sAMAccountName || '');
          setSelectUserModal(undefined);

          if (onSuccess) {
            onSuccess(selectedUser?.sAMAccountName || '');
          }
        }}
      />
    </>
  );
}

export default UserSearchInput;
